<template>
  <div id="app-container">
    <router-view />
    <VideoSplashScreen v-if="uiStore.isSplashScreenVisible" />
    <NotificationToast />
  </div>
</template>

<script setup>
import { useUiStore } from "./store/ui";
import VideoSplashScreen from "./components/VideoSplashScreen.vue";
import NotificationToast from "./components/NotificationToast.vue";

const uiStore = useUiStore();
</script>

<style>
/* Global styles are unchanged */
body {
  background-image: url("https://images.pexels.com/photos/176851/pexels-photo-176851.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  font-family: "Exo 2", sans-serif;
  margin: 0;
  padding: 0;
  color: #e0e0e0;
  background-color: #0a0a14;
}

#app-container {
  width: 100%;
  min-height: 100vh;
}

h1,
h2 {
  font-family: "Orbitron", sans-serif;
  color: #ffffff;
  text-shadow: 0 0 5px #ffffff, 0 0 15px #00f6ff, 0 0 25px #00f6ff;
}

button {
  font-family: "Orbitron", sans-serif;
  background: transparent;
  color: #00f6ff;
  border: 2px solid #00f6ff;
  border-radius: 5px;
  padding: 12px 24px;
  cursor: pointer;
  font-size: 16px;
  box-shadow: inset 0 0 10px rgba(0, 246, 255, 0.5),
    0 0 15px rgba(0, 246, 255, 0.3);
  transition: all 0.3s ease-in-out;
}

button:hover {
  background-color: rgba(0, 246, 255, 0.2);
  color: #ffffff;
  box-shadow: inset 0 0 15px rgba(0, 246, 255, 0.8),
    0 0 25px rgba(0, 246, 255, 0.7);
}

a {
  color: #ff00ff;
  text-decoration: none;
  font-weight: bold;
  text-shadow: 0 0 10px #ff00ff;
  transition: color 0.3s ease;
}

a:hover {
  color: #ffffff;
  text-decoration: underline;
}

/* Subtle cyan scrollbars; illuminate on panel/thumb hover */
* {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 246, 255, 0.22) transparent;
}

*:hover {
  scrollbar-color: rgba(0, 246, 255, 0.7) rgba(0, 246, 255, 0.08);
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-corner {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 246, 255, 0.2);
  border-radius: 99px;
  border: 2px solid transparent;
  background-clip: padding-box;
}

*:hover::-webkit-scrollbar-thumb {
  background-color: rgba(0, 246, 255, 0.5);
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 246, 255, 0.9);
  box-shadow: 0 0 10px rgba(0, 246, 255, 0.65);
}

::-webkit-scrollbar-thumb:active {
  background-color: #00f6ff;
  box-shadow: 0 0 14px rgba(0, 246, 255, 0.9);
}
</style>
